import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
    mutation ItemEventsShownMutation(
    $input: ItemEventsShownInput!
    ) {
        itemEventsShown(input: $input) {
            favoriteNotifications {
                hasNewEvents
            }
        }
    }
`;

const updateItemEventsShown = ({ environment, userId }) => {
    return commitMutation(
        environment, {
            mutation,
            variables: {
                input: {
                    userId
                }
            }
        }
    );
};


export default {commit: updateItemEventsShown};



// WEBPACK FOOTER //
// ./src/components/FavNotifications/ItemEventsShownMutation.js